import React from 'react'
import DocumentLink from '../common/DocumentLink'

const govCMSHome = process.env.REACT_APP_GOVCMS_HOME

const UnpaidWagesFooter = () => {
  return (
    <>
      <p>
        All personal information is collected and handled in line with our{' '}
        <a href={govCMSHome + '/Website-information/privacy'}>Privacy policy</a>
        .
      </p>
      <p className="sourceReference">
        Source reference for page:{' '}
        <a
          href="https://www.legislation.gov.au/C2009A00028/latest/text"
          className="external-link"
        >
          Fair Work Act 2009 section 559&nbsp;
        </a>
      </p>
      <h2>
        <a id="tools-and-resources" aria-hidden></a>
        Tools and resources
      </h2>
      <ul className="link-list">
        <li>
          <DocumentLink
            name="Unclaimed monies fact sheet"
            urlDoc="https://www.fairwork.gov.au/sites/default/files/migration/723/unclaimed-monies-fact-sheet.docx"
            urlPdf="https://www.fairwork.gov.au/sites/default/files/migration/723/unclaimed-monies-fact-sheet.pdf"
          />
        </li>
        <li>
          <a
            href="https://www.ato.gov.au/forms-and-instructions/superannuation-searching-for-lost-superannuation"
            className="external-link"
          >
            Australian Taxation Office – Searching for lost super
          </a>
        </li>
      </ul>
      <h2>
        <a id="related-information" aria-hidden></a>
        Related information
      </h2>
      <ul className="link-list">
        <li>
          <a href={govCMSHome + '/employment-conditions'}>
            Employment conditions
          </a>
        </li>
        <li>
          <a href={govCMSHome + '/leave'}>Leave</a>
        </li>
        <li>
          <a href={govCMSHome + '/pay-and-wages'}>Pay and wages</a>
        </li>
        <li>
          <a
            href={
              govCMSHome +
              '/about-us/compliance-and-enforcement/proactive-investigations'
            }
          >
            Proactive investigations
          </a>
        </li>
      </ul>
      <h3>Help for small business</h3>
      <ul>
        <li>
          Find tools, resources and information you might need in our{' '}
          <a
            href="https://smallbusiness.fairwork.gov.au/"
            aria-label="Small business showcase"
          >
            Small business showcase
          </a>
        </li>
      </ul>
    </>
  )
}

export default UnpaidWagesFooter
